var map = {
	"./DSCF6164.jpg": 1740,
	"./DSCF6190.jpg": 914,
	"./DSCF6199.jpg": 3193,
	"./DSCF6217.jpg": 9218,
	"./DSCF6222.jpg": 9546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7138;